import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-refresh-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './refresh-modal.html',
  styleUrl: './refresh-modal.scss'
})
export class RefreshModal {
  refreshElectron() {
    const win = window as any;
    if (win.windowControls && typeof win.windowControls.refresh === 'function') {
      win.windowControls.refresh();
    }
  }
}
